module.exports = function(app) {
	'use strict'
	app
	.constant('API_URL', window.settings.baseUrl)

	.config(['$stateProvider', '$urlRouterProvider','$httpProvider', function($stateProvider,$urlRouterProvider,$httpProvider) {

		$stateProvider.state('login', {
			url:'/',
			
			resolve:{
				refresh: ['refreshtokenService','$state','$rootScope','authtokenService','alertService','serverError', function(refreshtokenService,$state,$rootScope,authtokenService,alertService,serverError) {
					$rootScope.alerts = [];
					$rootScope.alertShow = false;
					var token = authtokenService.getToken();
					if(token && !$rootScope.isLogout) {
						return refreshtokenService.getAccessToken()
			               	.then(
			                function(answer) {
	                			if(answer==200) {
	                				if($rootScope.role_id == 'comments-moderator') {
	                					$state.go('app.allcomments');	
	                				} else {
	                    				$state.go('app.allposts');
	                				}
	                			}
			                },
			                function(error) {
			                  // report something
			                },
			                function(progress) {
			                 // report progress
			                });
					}
				  	return
		          }]
			},
			template: '<login-dir></login-dir>'
		});
		$stateProvider.state('app', {
			abstract: true,
			resolve: {          
				configData:['getConfigData','tabSessionService','$rootScope',function(getConfigData,tabSessionService,$rootScope){
					$rootScope.tabSessionId = tabSessionService.getSessionId();
					return getConfigData.getData('init')
				}]
			},
			template: require('./home.html'),
		});
		$stateProvider.state('app.dashboard', {
			url:'/dashboard',
			template: '<dashboard-dir></dashboard-dir>'
		});
		$stateProvider.state('app.logs', {
			url:'/logs',
			template: '<logs-dir></logs-dir>'
		});
		$stateProvider.state('app.allposts', {
			url:'^/posts/all?id',
			template: '<all-posts-dir></all-posts-dir>'
		});
		$stateProvider.state('app.myposts', {
			url:'^/my-posts/all?id',
			template: '<all-posts-dir my-posts="true"></all-posts-dir>'
		});
		$stateProvider.state('app.newpost', {
			url:'^/posts/new',
			template: '<post-dir></post-dir>'
		});
		$stateProvider.state('app.categories', {
			url:'^/posts/categories?id',
			template: '<categories-dir></categories-dir>'
		});
		$stateProvider.state('app.tags', {
			url:'^/posts/tags?id',
			template: '<tags-dir></tags-dir>'
		});
		// $stateProvider.state('app.us_election', {
		// 	url:'^/posts/us-election',
		// 	template: '<us-election-dir></us-election-dir>'
		// });
		// $stateProvider.state('app.allliveblogs', {
		// 	url:'^/blogs/all?id',
		// 	template: '<all-blogs-dir></all-blogs-dir>'
		// });
		// $stateProvider.state('app.newblog', {
		// 	url:'^/blogs/new',
		// 	template: '<blog-dir></blog-dir>'
		// });
		$stateProvider.state('app.agencies_allnews', {
			url:'^/news-services/agencies?id',
			template: '<news-services-dir type="agencies"></news-services-dir>'
		});
		$stateProvider.state('app.earthquakes_allnews', {
			url:'^/news-services/earthquakes?id',
			template: '<news-services-dir type="earthquakes"></news-services-dir>'
		});
		$stateProvider.state('app.newshub_allnews', {
			url:'^/news-services/newshub?id',
			template: '<news-services-dir type="newshub"></news-services-dir>'
		});
		$stateProvider.state('app.allpages', {
			url:'^/pages/all?id',
			template: '<all-pages-dir></all-pages-dir>'
		});
		$stateProvider.state('app.newpage', {
			url:'^/pages/new',
			template: '<page-dir></page-dir>'
		});
		$stateProvider.state('app.allapprovals', {
			url:'^/approvals/all',
			template: '<all-approvals-dir></all-approvals-dir>'
		});
		$stateProvider.state('app.allcountries', {
			url:'^/travel-restrictions/all-countries?id',
			template: '<all-countries-restriction-dir></all-countries-restriction-dir>'
		});
		$stateProvider.state('app.library', {
			url:'^/photos/all?id',
			template: '<media-library-dir></media-library-dir>'
		});
		$stateProvider.state('app.newmedia', {
			url:'^/photos/new',
			template: '<new-media-dir></new-media-dir>'
		});
		$stateProvider.state('app.related_galleries', {
			url:'^/photos/related-galleries',
			template: '<related-galleries-dir></related-galleries-dir>'
		});
		$stateProvider.state('app.ai_all_configurations', {
			url:'^/ai/configurations/all?id',
			template: '<ai-all-configurations-dir></ai-all-configurations-dir>'
		});
		$stateProvider.state('app.ai_create_config', {
			url:'^/ai/configurations/create',
			template: '<ai-configuration-dir></ai-configuration-dir>'
		});
		$stateProvider.state('app.allusers', {
			url:'^/users/all?id',
			template: '<all-users-dir></all-users-dir>'
		});
		$stateProvider.state('app.newuser', {
			url:'^/users/new',
			template: '<user-dir></user-dir>'
		});
		$stateProvider.state('app.profile', {
			url:'^/users/your-profile',
			template: '<profile-dir></profile-dir>'
		});
		$stateProvider.state('app.allpolls', {
			url:'^/polls/all?id',
			template: '<all-polls-dir></all-polls-dir>'
		});
		$stateProvider.state('app.newpoll', {
			url:'^/polls/new',
			template: '<poll-dir></poll-dir>'
		});
		$stateProvider.state('app.allratings', {
			url:'^/ratings/all?id',
			template: '<all-ratings-dir></all-ratings-dir>'
		});
		$stateProvider.state('app.newrating', {
			url:'^/ratings/new',
			template: '<rating-dir></rating-dir>'
		});
		// $stateProvider.state('app.allfocus', {
		// 	url:'^/focus-news/all',
		// 	template: '<all-focus-dir></all-focus-dir>'
		// });
		// $stateProvider.state('app.allfocustabs', {
		// 	url:'^/focus-news/focus-tabs',
		// 	template: '<focus-tabs-dir></focus-tabs-dir>'
		// });
		// $stateProvider.state('app.weatherfocus', {
		// 	url:'^/focus-news/focus-weather',
		// 	template: '<focus-weather-dir></focus-weather-dir>'
		// });
		// $stateProvider.state('app.allnewsticker', {
		// 	url:'^/news-ticker',
		// 	template: '<news-ticker-dir></news-ticker-dir>'
		// });
		$stateProvider.state('app.allpopularposts', {
			url:'^/popular-posts',
			template: '<popular-posts-dir></popular-posts-dir>'
		});
		// $stateProvider.state('app.macrosites_related_news', {
		// 	url:'^/macrosites/related-news',
		// 	template: '<macrosites-related-news-dir></macrosites-related-news-dir>'
		// });
		$stateProvider.state('app.macrosites_focus_news', {
			url:'^/telegraf/focus-news',
			template: '<macrosites-focus-news-dir></macrosites-focus-news-dir>'
		});
		$stateProvider.state('app.allcomments', {
			url:'^/comments/post',
			template: '<all-comments-dir></all-comments-dir>'
		});
		$stateProvider.state('app.highlightwords', {
			url:'^/comments/highlight-words',
			template: '<highlight-words-dir></highlight-words-dir>'
		});
		$stateProvider.state('app.allvideocomments', {
			url:'^/comments/video',
			template: '<all-comments-dir></all-comments-dir>'
		});
		$stateProvider.state('app.menus', {
			url:'^/menus?id',
			template: '<menus-dir></menus-dir>'
		});
		$stateProvider.state('app.allpush', {
			url:'^/notification/all',
			template: '<all-notifications-dir></all-notifications-dir>'
		});
		$stateProvider.state('app.allpush_eklinika', {
			url:'^/notification/eklinika',
			template: '<all-notifications-dir type="eklinika"></all-notifications-dir>'
		});
		$stateProvider.state('app.notificationsettings', {
			url:'^/notification/settings',
			template: '<notification-settings-dir></notification-settings-dir>'
		});
		
		$stateProvider.state('app.allvideos', {
			url:'^/videos/all?id',
			template: '<all-videos-dir></all-videos-dir>'
		});
		$stateProvider.state('app.newvideo', {
			url:'^/videos/new',
			template: '<new-video-dir></new-video-dir>'
		});
		$stateProvider.state('app.newvideo_mediaoutcast', {
			url:'^/videos/new-mediaoutcast',
			template: '<new-video-mediaoutcast-dir></new-video-mediaoutcast-dir>'
		});
		$stateProvider.state('app.video_categories', {
			url:'^/videos/categories?id',
			template: '<video-categories-dir></video-categories-dir>'
		});
		$stateProvider.state('app.video_tags', {
			url:'^/videos/tags?id',
			template: '<video-tags-dir></video-tags-dir>'
		});
		$stateProvider.state('app.video_livestream', {
			url:'^/videos/livestream',
			template: '<livestream-dir></livestream-dir>'
		});
		$stateProvider.state('app.video_related_box', {
			url:'^/videos/related-video-box',
			template: '<related-video-box-dir></related-video-box-dir>'
		});
		// $stateProvider.state('app.allcatalogs', {
		// 	url:'^/catalogs/all?id',
		// 	template: '<all-catalogs-dir></all-catalogs-dir>'
		// });
		// $stateProvider.state('app.newcatalog', {
		// 	url:'^/catalogs/new',
		// 	template: '<catalog-dir></catalog-dir>'
		// });
		// $stateProvider.state('app.catalog_categories', {
		// 	url:'^/catalogs/categories?id',
		// 	template: '<catalog-categories-stores-dir></catalog-categories-stores-dir>'
		// });
		// $stateProvider.state('app.stores', {
		// 	url:'^/catalogs/stores?id',
		// 	template: '<catalog-categories-stores-dir></catalog-categories-stores-dir>'
		// });
		// $stateProvider.state('app.catalog_tags', {
		// 	url:'^/catalogs/tags?id',
		// 	template: '<catalog-tags-dir></catalog-tags-dir>'
		// });
		// $stateProvider.state('app.custom_widget', {
		// 	url:'^/esports/custom-widget',
		// 	template: '<custom-widget-dir></custom-widget-dir>'
		// });
		$stateProvider.state('app.banner_slider', {
			url:'^/ads/banner-slider',
			template: '<banner-slider-dir></banner-slider-dir>'
		});
		$stateProvider.state('app.txt', {
			url:'^/ads/ads-txt',
			template: '<ads-txt-dir></ads-txt-dir>'
		});
		$stateProvider.state('app.adosettings', {
			url:'^/ads/settings',
			template: '<ads-settings-dir></ads-settings-dir>'
		});
		// $stateProvider.state('app.allblic', {
		// 	url:'^/blic-exchange/all',
		// 	template: '<all-blic-dir></all-blic-dir>'
		// });
		// $stateProvider.state('app.groupphase', {
		// 	url:'^/world-cup-2018/group-phase',
		// 	template: '<group-phase-dir></group-phase-dir>'
		// });
		// $stateProvider.state('app.uploadgroupe', {
		// 	url:'^/world-cup-2018/upload-group-e',
		// 	template: '<upload-group-dir></upload-group-dir>'
		// });
		// $stateProvider.state('app.knockoutphase', {
		// 	url:'^/world-cup-2018/knockout-phase',
		// 	template: '<knockout-phase-dir></knockout-phase-dir>'
		// })
		$urlRouterProvider.otherwise('/');
		$httpProvider.interceptors.push('authInterceptor');
		$httpProvider.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
		$httpProvider.defaults.useXDomain = true;
        delete $httpProvider.defaults.headers.common['X-Requested-With'];
	}])
	// .run(['$state','configData', ,function($state, configData) {
	// 	for(var index=0;index<configData.newsServices.length;index++) {
	// 		$state.state('app.'+configData.newsServices[index]+'_allnews', {
	// 			url:'^/news-services/'+configData.newsServices[index]+'?id',
	// 			template: '<news-services-dir type="'+ configData.newsServices[index]+'"></news-services-dir>'
	// 		});
	// 	}
	// }])
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/appRouteConfig.js
// module id = 425
// module chunks = 0